module.exports = __webpack_public_path__ + "04_medium_brown.594627c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/04_medium_brown.png
// module id = rnYW
// module chunks = 0